import { NextPage } from 'next';
import ErrorView from '../components/ErrorPage';
import { PageProps } from './_app';

const NotFoundError: NextPage<PageProps> = () => {
  return <ErrorView statusCode={404} />;
};

export default NotFoundError;
